export const API_CONFIG = {
    DOCUMENTS_BASE_URL: process.env.NODE_ENV === 'production' 
        ? 'https://itansar.ru/docs' 
        : 'http://localhost:3001/api/v1',
    
    DOCUMENTS_ENDPOINTS: {
        GET_DOCUMENT: (filename: string) => `/documents/${filename}`,
        LIST_DOCUMENTS: '/documents',
        UPLOAD_DOCUMENT: '/documents',
    }
};

export const getDocumentUrl = (filename: string): string => {
    return `${API_CONFIG.DOCUMENTS_BASE_URL}${API_CONFIG.DOCUMENTS_ENDPOINTS.GET_DOCUMENT(filename)}`;
}; 